import React, { useState } from "react";
import CheckPointForm from "./CheckPointForm";
import useCheckPointFullHook from "./useCheckPointFullHooks";
import { useNavigate } from "react-router-dom"; // for back button

const ITEMS_PER_PAGE = 5;

const CheckPointLists = () => {
  const {
    checkpoints,
    formData,
    setFormData,
    submitForm,
    editCheckpoint,
    setEditCheckpoint,
    handleEdit,
    fetchCheckpoints,
    resetForm,
  } = useCheckPointFullHook();

  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [showSkillsModal, setShowSkillsModal] = useState(false);
  const navigate = useNavigate(); // for back button

  const openAddModal = () => {
    resetForm();
    setShowModal(true);
  };

  const openEditModal = (checkpoint) => {
    handleEdit(checkpoint);
    setTimeout(() => setShowModal(true), 0);
  };

  const openSkillsModal = (skills) => {
    setSelectedSkills(skills);
    setShowSkillsModal(true);
  };

  const closeSkillsModal = () => {
    setSelectedSkills([]);
    setShowSkillsModal(false);
  };

  const closeModal = () => {
    setShowModal(false);
    resetForm();
  };

  const onSuccess = () => {
    fetchCheckpoints();
    closeModal();
  };

  // Pagination logic
  const totalPages = Math.ceil(checkpoints.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentCheckpoints = checkpoints.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <div className="p-6 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Checkpoint List</h2>
        <div className="flex gap-3">
          <button
            onClick={() => navigate(-1)}
            className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md shadow-md"
          >
            ← Back
          </button>
          <button
            onClick={openAddModal}
            className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-md shadow-md"
          >
            + Add Checkpoint
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border shadow-md rounded-lg overflow-hidden">
          <thead className="bg-blue-50 text-blue-700 text-left">
  <tr>
    <th className="border-b px-4 py-3">S.no</th>
    <th className="border-b px-4 py-3">Name</th>
    <th className="border-b px-4 py-3">District</th>
    <th className="border-b px-4 py-3">State</th>
    <th className="border-b px-4 py-3">Pincode</th>
    <th className="border-b px-4 py-3">Gender</th>
    <th className="border-b px-4 py-3">Landmark</th>
    <th className="border-b px-4 py-3">Start Date</th>
    <th className="border-b px-4 py-3">Start Time</th>
    <th className="border-b px-4 py-3">End Date</th>
    <th className="border-b px-4 py-3">End Time</th>
    <th className="border-b px-4 py-3">Deputation</th>
    <th className="border-b px-4 py-3">Status</th>
    <th className="border-b px-4 py-3">Skills</th>
    <th className="border-b px-4 py-3">Actions</th>
  </tr>
</thead>
<tbody>
  {currentCheckpoints.length === 0 ? (
    <tr>
      <td colSpan="15" className="text-center text-gray-500 py-6">
        No checkpoints available.
      </td>
    </tr>
  ) : (
    currentCheckpoints.map((cp, index) => (
      <tr key={cp.DeputyCheckpointId} className="hover:bg-gray-50 transition duration-200">
        <td className="border-b px-4 py-3">{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
        <td className="border-b px-4 py-3">{cp.DeputyCheckpointName}</td>
        <td className="border-b px-4 py-3">{cp.DistrictName}</td>
        <td className="border-b px-4 py-3">{cp.StateName}</td>
        <td className="border-b px-4 py-3">{cp.Pincode}</td>
        <td className="border-b px-4 py-3">{cp.Gender.trim()}</td>
        <td className="border-b px-4 py-3">{cp.LandMark}</td>
        <td className="border-b px-4 py-3">{cp.StartDate?.split("T")[0]}</td>
        <td className="border-b px-4 py-3">{cp.StartTime}</td>
        <td className="border-b px-4 py-3">{cp.EndDate?.split("T")[0]}</td>
        <td className="border-b px-4 py-3">{cp.EndTime}</td>
        <td className="border-b px-4 py-3">{cp.NoOfDeputation}</td>
        <td className="border-b px-4 py-3">
          {cp.Status === 1 ? (
            <span className="text-green-600 font-semibold">Active</span>
          ) : (
            <span className="text-red-600 font-semibold">Inactive</span>
          )}
        </td>
        <td className="border-b px-4 py-3">
          <button
            onClick={() => openSkillsModal(cp.CheckpointSkills || [])}
            className="text-blue-600 underline hover:text-blue-800 text-sm"
          >
            View Skills
          </button>
        </td>
        <td className="border-b px-4 py-3">
          <button
            onClick={() => openEditModal(cp)}
            className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-1 rounded-md shadow-sm"
          >
            Edit
          </button>
        </td>
      </tr>
    ))
  )}
</tbody>

        </table>
      </div>

      {/* Pagination Controls */}
      {checkpoints.length > ITEMS_PER_PAGE && (
        <div className="flex justify-center items-center gap-4 mt-6">
          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            className={`px-4 py-2 rounded-md ${currentPage === 1 ? "bg-gray-300" : "bg-blue-500 text-white"}`}
          >
            Previous
          </button>
          <span className="text-gray-700">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 rounded-md ${currentPage === totalPages ? "bg-gray-300" : "bg-blue-500 text-white"}`}
          >
            Next
          </button>
        </div>
      )}

      {/* Form Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg w-full max-w-xl relative">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-black"
            >
              ✕
            </button>
            <h3 className="text-lg font-semibold px-6 pt-6">
              {editCheckpoint ? "Edit Checkpoint" : "Add Checkpoint"}
            </h3>
            <div className="max-h-[80vh] overflow-y-auto px-6 pb-6">
              <CheckPointForm
                formData={formData}
                setFormData={setFormData}
                submitForm={submitForm}
                onSuccess={onSuccess}
                editCheckpoint={editCheckpoint}
              />
            </div>
          </div>
        </div>
      )}

      {/* Skills Modal */}
      {showSkillsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg w-full max-w-md p-6 relative">
            <button
              onClick={closeSkillsModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-black"
            >
              ✕
            </button>
            <h3 className="text-lg font-semibold mb-4">Checkpoint Skills</h3>
            {selectedSkills.length > 0 ? (
              <ul className="list-disc pl-5 space-y-1">
                {selectedSkills.map((skill, idx) => (
                  <li key={skill.SkillId || idx} className="text-gray-700">
                    {skill.SkillName}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500">No skills found for this checkpoint.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckPointLists;